import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./AddProperties.css";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

import uniqid from "uniqid";

// Form Validate imports Start
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End

// Property Controller Methods
import AddProperty from "../../controllers/properties/addProperty";
import GetActiveAgents from "../../controllers/agents/GetActiveAgents";
import GetAllLeads from "../../controllers/leads/GetAllLeads";

// Material ui Stepper
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import { Fab } from "@mui/material";

// Sections
import Type from "./Type/Type";
import Details from "./Details/Details";
import Images from "./Images/Images";
import Contact from "./Contact/Contact";
import { getAuth } from "firebase/auth";
import convertObjectToArray from "../../helpers/convertObjectToArray";
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  listAll,
  ref,
  uploadBytes,
} from "firebase/storage";
import GetProperty from "../../controllers/properties/getProperty";
import UpdateProperty from "../../controllers/properties/updateProperty";
import GetAdmin from "../../controllers/Enquiries/GetAdmin";
import getSubCategory from "../../controllers/properties/getSubCategory";
import GetLandUnits from "../../controllers/properties/GetLandUnits";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import getSettings from "../../controllers/settings/getSettings";
import {
  arrayRemove,
  doc,
  FieldValue,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";

const generatePropertyId = () => uniqid() + uniqid() + uniqid();
let propertyId = null;
let UploadingImages = [];
let UploadedImages = [];

let displayName = "";
let uid = "";
let SubmitClicked = false;

const AddProperties = () => {
  // Currency Settings UseEffect Start
  const [isPropertyLoaded, setIsPropertyLoaded] = useState(false);
  const [CurrencySettings, setCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setCurrencySettings(settings);
    }
    fetchData();
  }, []);
  // Currency Settings UseEffect End

  const navigate = useNavigate();
  const location = useLocation();

  // Form Validate const Start
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  // Form Validate const End

  useEffect(() => {
    getAuth().onAuthStateChanged(() => {
      const obj = getAuth().currentUser;
      displayName = obj.displayName;
      uid = obj.uid;
    });
  }, []);

  const [Refresh, setRefresh] = useState(false);
  const [LeadRefresh, setLeadRefresh] = useState(false);
  const toggleRefresh = () => {
    setRefresh(!Refresh);
  };

  const [InterstitialLoader, setInterstitialLoader] = useState(false);
  const [agentId, setAgentId] = useState(uid);

  const [UploadingImagesThreadInAction, setUploadingImagesThreadInAction] =
    useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const __lead = useRef(null);
  const __agent = useRef(null);
  const get__lead = () => __lead.current;
  const set__lead = (val) => {
    setValue("lead", val);
    __lead.current = val;
  };
  const get__agent = () => __agent.current;
  const set__agent = (val) => {
    setValue("agent", val.id);
    __agent.current = val;
  };

  const [HomeCat, setHomeCat] = useState([]);
  const [PlotCat, setPlotCat] = useState([]);
  const [CommercialCat, setCommercialCat] = useState([]);
  const [LandUnits, setLandUnits] = useState([]);

  const [SelectedCity, setSelectedCity] = useState(null);
  const [coordinates, setSelectedCord] = useState({
    lat: null,
    lng: null,
  });
  const [SelectedLocation, setSelectedLocation] = useState(null);
  // const [SelectedLocation, setSelectedLocation] = useState({ name: "" });

  // Property Sub Category UseEffect Start
  useEffect(() => {
    async function fetchData() {
      const cat = await getSubCategory();

      setHomeCat([...cat.home]);
      setPlotCat([...cat.plot]);
      setCommercialCat([...cat.commercial]);
    }
    fetchData();
  }, []);
  // Property Sub Category UseEffect End

  // Property Sub Category UseEffect Start
  useEffect(() => {
    async function fetchData() {
      const units = await GetLandUnits();
      setLandUnits([...units]);
    }
    fetchData();
  }, []);
  // Property Sub Category UseEffect End

  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [imageSrc, setImageSrc] = useState(undefined);
  const updateFiles = (incommingFiles) => {
    setFiles(incommingFiles);
  };
  const onDelete = (id) => {
    setFiles(files.filter((x) => x.id !== id));
  };
  const handleSee = (imageSource) => {
    setImageSrc(imageSource);
  };
  const handleClean = (files) => {};
  const updateNewFilesStatus = () => {
    let a = [...files];
    a = a.map((file) => {
      return { ...file, uploadStatus: file.uploadStatus || "uploading" };
    });
    setFiles(a);
  };

  const [myFiles, setMyFiles] = useState([]);
  const markAsUploaded = (__ID, url = "") => {
    let a = [...files];

    a = a.map((file) => {
      return {
        ...file,
        uploadStatus: file.id === __ID ? "success" : file.uploadStatus,
        // url,
      };
    });
    setFiles([...a]);
    // setMyFiles([...a]);
  };
  const uploadImages = async () => {
    for (let index = 0; index < files.length; index++) {
      if (
        files[index].uploadStatus &&
        files[index].uploadStatus !== "uploading"
      )
        continue;
      const { file, id, valid } = files[index];
      const { type } = file;
      const __ext = type.split("/").pop();
      const __path = ref(
        getStorage(),
        `properties/${propertyId}/${id}.${__ext}`
      );
      await uploadBytes(__path, file).then(async (snapshot) => {
        files[index].url = await getDownloadURL(snapshot.ref);
        await markAsUploaded(
          files[index].id,
          await getDownloadURL(snapshot.ref)
        );
      });
    }
    uploadFinish();
  };
  const uploadStart = () => {
    setIsUploading(true);
    updateNewFilesStatus();
    uploadImages();
  };
  const uploadFinish = () => {
    setTimeout(() => {
      setIsUploading(false);
    }, 2000);
  };
  useEffect(() => {
    if (files.length === 0) return;
    if (isUploading) return;
    uploadStart();
  }, [files]);

  const [oldImages, setOldImages] = useState([]);
  const delOldImage = (imgURL, propertyId, i) => {
    /**
     * Deletes image from server
     */
    deleteObject(ref(getStorage(), imgURL)).then(async () => {
      // File deleted successfully

      // remove the image link from firebase
      let imagesAfterDeletion = oldImages.filter((a) => a !== imgURL);

      console.log(imagesAfterDeletion);
      let docRef = await doc(db, "properties", propertyId);
      setDoc(
        docRef,
        {
          images: imagesAfterDeletion,
        },
        { merge: true }
      )
        .then(() => {
          console.log("deleted");
        })
        .catch((err) => console.log(err));
      // docRef.update({
      //   images: FieldValue.arrayRemove(i),
      // });

      setOldImages(oldImages.filter((a) => a !== imgURL));
    });
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const [agentData, setAgentData] = useState([]);
  const [leadData, setLeadData] = useState([]);
  const [leadDataFetched, setleadDataFetched] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const visited = useRef({});
  const formSubmitButton = useRef(null);

  const isStepVisited = (index = activeStep) =>
    ![null, undefined].includes(visited.current[index]);

  const markStepVisited = (index = activeStep) =>
    (visited.current[index] = true);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    const EntriesCompleted = () => {
      let res = true;
      Object.keys(completed).forEach((entry) => {
        if (completed[entry] == false) res = false;
      });
      return res;
    };
    return completedSteps() === totalSteps() && EntriesCompleted();
  };

  const handleNext = () => {
    markStepVisited();
    const newActiveStep = (activeStep + 1) % totalSteps();
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    markStepVisited();
    formSubmitButton.current.click();
    setActiveStep(step);
  };

  const handleComplete = (stepNo = activeStep) => {
    if (completed[stepNo] === true) return;
    const newCompleted = completed;
    newCompleted[stepNo] = true;
    setCompleted({ ...newCompleted });
    // if (!isLastStep()) handleNext();
  };

  const handleUnComplete = (stepNo = activeStep) => {
    if (completed[stepNo] === false) return;
    const newCompleted = completed;
    newCompleted[stepNo] = false;
    setCompleted({ ...newCompleted });
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const handleImageChange = (e) => {
    if (e.target.files) {
      const filesArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      let files = convertObjectToArray(e.target.files);

      files = files.map((file, index) => {
        return {
          id: uniqid(),
          name: file.name,
          type: file.type,
          blob: filesArray[index],
          file,
          uploading: false,
          uploaded: false,
        };
      });

      setSelectedImages([...selectedImages, ...files]);
      setSelectedFiles(filesArray);
      // setSelectedFiles((prevImages) => prevImages.concat(filesArray));
      Array.from(e.target.files).map(
        (file) => URL.revokeObjectURL(file) // avoid memory leak
      );

      // setTimeout(() => {
      //   uploadImages();
      // }, 2000);
    }
  };

  /**
   * Checks if form is in edit mode, then data has loaded or not
   * @returns Boolean
   */
  const isFormLoaded = () =>
    GetFormMode() === "add"
      ? true
      : watch().rentalPrice !== undefined
      ? true
      : false;

  /**
   * Form mode
   * >> This form is used for 2 purposes i.e adding a new property
   * and updating an existing property
   *
   * - If url contains edit then the form is in edit mode else
   * the form is in add mode
   *  */
  const GetFormMode = () =>
    location.pathname.includes("/edit/") ? "edit" : "add";

  /**
   * Set Property Id
   *
   * - If Form mode = add, then generate new id
   * - If Form mode = edit, then get id from url
   * - If url contains # in the end, remove the #
   *  */
  useEffect(() => {
    propertyId =
      GetFormMode() === "edit"
        ? location.pathname.split("/").pop()
        : generatePropertyId();
    propertyId = propertyId.endsWith("#")
      ? propertyId.substring(0, propertyId.length - 1)
      : propertyId;
  }, []);

  /**
   * Get Property Data and populate in form
   */

  /**
   * Get Property Data and populate in form
   */

  useEffect(() => {
    const fetchProperty = async () => {
      if (propertyId === null || GetFormMode() === "add") return;
      const p = await GetProperty(propertyId);

      /**
       * Set Value of react hook form variables
       */
      const z = Object.entries(p);
      for (let index = 0; index < z.length; index++)
        setValue(z[index][0], z[index][1]);

      setSelectedCity({ name: p.city });
      setSelectedLocation({ name: p.address });

      set__lead(watch("lead"));

      setIsPropertyLoaded(true);
      /**
       * Get images for the particular property on server
       */
      const imagesRef = ref(getStorage(), `properties/${propertyId}`);
      listAll(imagesRef)
        .then(async (res) => {
          let ls = [];

          for (let index = 0; index < res.items.length; index++)
            ls.push(await getDownloadURL(res.items[index]));

          /** Removing duplicates */
          ls = [...Array.from(new Set(ls))];

          setOldImages([...ls]);
        })
        .catch((error) => {
          // Uh-oh, an error occurred!
        });
    };
    fetchProperty();
  }, [propertyId]);

  const stepCompletionLookup = (lookupStep = activeStep) => {
    switch (lookupStep) {
      case 0:
        (watch("availableForSale") === false &&
          watch("availableForRent") === false) ||
        watch("propertyType") === "" ||
        watch("propertySubType") === "" ||
        !watch("city") ||
        !watch("address")
          ? handleUnComplete()
          : handleComplete();
        break;
      case 1:
        watch("propertyTitle") === "" ||
        (!watch("rentalPrice") && !watch("sellingPrice")) ||
        (watch("availableForRent") &&
          (watch("rentalPrice") === "" || watch("rentalPrice") === "0")) ||
        (watch("availableForSale") &&
          (watch("sellingPrice") === "" || watch("sellingPrice") === "0")) ||
        watch("landArea") === "" ||
        watch("landArea") === "0" ||
        watch("landAreaLength") === "" ||
        watch("landAreaLength") === "0" ||
        watch("landAreaWidth") === "" ||
        watch("landAreaWidth") === "0" ||
        watch("landAreaUnit") === "" ||
        (watch("propertyType") !== "Plot" && watch("bedrooms") === "") ||
        (watch("propertyType") !== "Plot" && watch("bathrooms") === "")
          ? handleUnComplete(lookupStep)
          : handleComplete(lookupStep);
        break;
      case 2:
        isUploading ? handleUnComplete() : handleComplete();
        break;
      case 3:
        watch("name") === "" ||
        watch("phone") === "" ||
        watch("lead") === "" ||
        watch("agent") === ""
          ? handleUnComplete()
          : handleComplete();
        break;
      case 4:
        agentId !== "" && watch("lead")?.length > 0
          ? handleComplete()
          : handleUnComplete();
        break;
    }
  };

  const steps = [
    {
      tagline: "Property Type and Location",
      // headline: "Property Type And Location",
      // shortline: "Elaborate the property type in detail",
      component: (
        <Type
          {...{
            register,
            errors,
            watch,
            setValue,
            stepCompletionLookup,
            propertyId,
            isStepVisited,
            HomeCat,
            PlotCat,
            CommercialCat,
            SelectedCity,
            setSelectedCord,
            setSelectedCity,
            SelectedLocation,
            setSelectedLocation,
          }}
        />
      ),
    },
    {
      tagline: "Property Details",
      // headline: "Property Details",
      // shortline: "Elaborate the property type in detail",
      component: (
        <Details
          {...{
            register,
            errors,
            watch,
            setValue,
            propertyId,
            isStepVisited,
            LandUnits,
            CurrencySettings,
          }}
        />
      ),
    },
    {
      tagline: "Images",
      // headline: "Images",
      // shortline: "Elaborate the property type in detail",
      component: (
        <Images
          {...{
            register,
            errors,
            handleImageChange,
            Images: selectedImages,
            propertyId,
            files,
            setFiles,
            isUploading,
            setIsUploading,
            imageSrc,
            setImageSrc,
            updateFiles,
            onDelete,
            handleSee,
            handleClean,
            updateNewFilesStatus,
            markAsUploaded,
            uploadImages,
            uploadStart,
            uploadFinish,
            isStepVisited,
            oldImages,
            delOldImage,
          }}
        />
      ),
    },
    {
      tagline: "Contact Details",
      // headline: "Contact Details",
      // shortline: "Elaborate the property type in detail",
      component: (
        <Contact
          {...{
            register,
            errors,
            Agents: agentData,
            Leads: leadData,
            setAgent: (id) => setAgentId(agentId === id ? "" : id),
            agentId,
            propertyId,
            watch,
            setValue,
            set__agent,
            get__agent,
            get__lead,
            set__lead,
            isStepVisited,
            toggleRefresh,
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    // To Fetch Agents
    async function fetchData() {
      let agent = await GetActiveAgents();
      agent = agent.map((a) => {
        return { ...a, role: "agent", img: "" };
      });

      const admin = await GetAdmin();
      agent.unshift(admin);

      let selected_agent =
        getLocalStorageItem("role") === "admin"
          ? admin
          : agent.filter(({ uid }) => uid === getAuth().currentUser.uid).pop();

      set__agent(selected_agent);

      setAgentData(agent);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const leads = (await GetAllLeads("*", "newest", "*", 1000)).leads;
      setleadDataFetched(true);
      // if(get__lead() === null)
      if (leads !== []) {
        if (leadDataFetched === true) set__lead(leads[0].id);
      }

      setLeadData(leads);
    }
    fetchData();
  }, [Refresh]);
  useEffect(() => {
    stepCompletionLookup();
    setTimeout(async () => {
      // handleSubmit(() => {})();
      stepCompletionLookup();
    }, 1000);
  }, [agentId, selectedFiles, watch(), UploadingImages, UploadedImages]);

  useEffect(() => {
    setValue("propertySubType", "");
    stepCompletionLookup(1);
  }, [watch("propertyType")]);

  let testArray = [];
  const submitForm = async (e) => {
    if (!SubmitClicked) return;

    files.map((file) => {
      testArray.push(file);
    });
    if (!allStepsCompleted()) return;
    e = watch();
    setIsDisabled(true);
    e = {
      ...e,
      propertyTitle:
        e.propertyTitle.charAt(0).toUpperCase() +
        e.propertyTitle.slice(1).toLowerCase(),
      description:
        e.description.charAt(0).toUpperCase() +
        e.description.slice(1).toLowerCase(),
      bathrooms: e.bathrooms * 1 || 0,
      bedrooms: e.bedrooms * 1 || 0,
      // landArea: e.landArea * 1 || LandAreaLength * LandAreaWidth,
      landArea: e.landArea * 1,
      landAreaLength: e.landAreaLength * 1 || 0,
      landAreaWidth: e.landAreaWidth * 1 || 0,
      rentalPrice: e.rentalPrice * 1 || 0,
      sellingPrice: e.sellingPrice * 1 || 0,
      agent: watch("agent") || agentId,
      images: [...(watch("images") || []), ...files.map(({ url }) => url)],
      // lead:leadId,
      // images: UploadedImages,
    };

    // if property added successfully, navigate to properties page
    if (
      (GetFormMode() === "add" && (await AddProperty(propertyId, e))) ||
      (GetFormMode() === "edit" &&
        (await UpdateProperty(propertyId, e, oldImages)))
    ) {
      propertyId = generatePropertyId();
      navigate("/user/properties");
    } else {
      SubmitClicked = false;
      setIsDisabled(false); // else active the form to re edit
    }
  };
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    goToTop();
  }, [activeStep]);

  return (
    <>
      <div className="global-body-container">
        <div
          className="d-flex align-items-start"
          style={{
            marginBottom: 20,
          }}
        >
          <button onClick={() => navigate(-1)} className="custom-back-btn">
            <ArrowBackIosRoundedIcon className="custom-back-btn-icon" />
            <span>Back</span>
          </button>

          <div
            className="mr-auto d-lg-block"
            style={{
              marginTop: 5,
              marginLeft: 23,
            }}
          >
            <h2 className="custom-heading text-capitalize">
              {GetFormMode()} Property
            </h2>
          </div>
        </div>
        {isFormLoaded() &&
          //if form is used for adding donot check if the property isloaded
          (GetFormMode() === "add" ? true : isPropertyLoaded) && (
            <Fragment>
              <Box className="container mb-4">
                <Stepper activeStep={activeStep}>
                  {steps.map(({ tagline }, index) => (
                    <Step key={tagline} completed={completed[index]}>
                      <StepButton
                        color="#4e36a8"
                        onClick={handleStep(index)}
                        style={{
                          background: "none",
                          boxShadow: "none",
                          textTransform: "none",
                        }}
                      >
                        {tagline}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
              </Box>

              <form
                onSubmit={handleSubmit(submitForm)}
                onChange={stepCompletionLookup}
              >
                <React.Fragment>
                  <div className="col-12 col-xl-6 col-xxl-6 col-lg-12 col-md-12 pt-4 m-auto addPropertyPageContent">
                    <div className="card bg-box">
                      <div className="card-body">
                        <h4 className="card-title pt-1">
                          {steps[activeStep].headline}
                        </h4>
                        <h5 className="card-text">
                          {steps[activeStep].shortline}
                        </h5>
                        <div className="my-5">
                          {steps[activeStep].component}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>

                {/* Floating Buttons */}
                <div className="next-back-btns-container">
                  <span className="FloatingButtonContainerBack p-4">
                    <button
                      className="form-submit-button"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      style={{
                        width: "100px",
                        height: "50px",
                      }}
                    >
                      Back
                    </button>
                  </span>

                  <span className="FloatingButtonContainer p-4">
                    {(!allStepsCompleted() ||
                      activeStep + 1 !== totalSteps()) &&
                      (completed[activeStep] ? (
                        <button
                          className="form-submit-button"
                          style={{
                            width: "100px",
                            height: "50px",
                          }}
                          type="submit"
                          ref={formSubmitButton}
                          onClick={handleNext}
                        >
                          Next
                        </button>
                      ) : (
                        <button
                          className="form-submit-button"
                          style={{
                            width: "100px",
                            height: "50px",
                          }}
                          disabled
                        >
                          Next
                        </button>
                      ))}

                    {
                      allStepsCompleted() &&
                        activeStep + 1 === totalSteps() &&
                        (!isDisabled ? (
                          <button
                            className="form-submit-button"
                            style={{
                              width: "100px",
                              height: "50px",
                            }}
                            type="submit"
                            ref={formSubmitButton}
                            onClick={() => {
                              SubmitClicked = true;
                              submitForm();
                            }}
                          >
                            {GetFormMode() === "add" ? "Save" : "Update"}
                          </button>
                        ) : (
                          <button
                            disabled
                            className="form-submit-button"
                            style={{
                              width: "100px",
                              height: "50px",
                            }}
                          >
                            {isDisabled && (
                              <span className="spinner-border spinner-border-sm mr-1 text-capitalize"></span>
                            )}
                            {GetFormMode() === "add" ? "Save" : "Update"}
                          </button>
                        ))

                      // <Fab
                      //   variant="extended"
                      //   size="large"
                      //   type="submit"
                      //   className="active-btn"
                      //   onClick={() => {
                      //     SubmitClicked = true;
                      //     submitForm();
                      //   }}
                      //   disabled={isDisabled}
                      // >
                      //   {isDisabled && (
                      //     <span className="spinner-border spinner-border-sm mr-1 text-capitalize"></span>
                      //   )}
                      //   {GetFormMode() === "add" ? "Save" : "UPDATE"}
                      // </Fab>
                    }
                  </span>
                </div>
              </form>

              {/* Loader */}
              {isDisabled && (
                <div className="interstitial-loader">
                  <div class="spinner-border" role="status"></div>
                  <span class="sr-only">Loading...</span>
                </div>
              )}
            </Fragment>
          )}
      </div>
    </>
  );
};

export default AddProperties;
